import api from 'api';

const accept_url = id => `/api/reservations/${id}/accept`;
const decline_url = id => `/api/reservations/${id}/decline`;

export default {
    accept: id => api.get({path: accept_url(id)}),
    decline: id => api.get({path: decline_url(id)})
}